import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import { useMemo } from "react";
import Table from "./Table";
import { useFeatureFlag } from "../context/FeatureFlagContext";

const Selection = ({
	headerText,
	currentSelection,
	onSelection,
	tableRows,
	famFilterOpts,
	manFilterOpts,
	onShowAll,
	dataType = 'ball',
	insufficientData = false,
}) => {
	const { enabled: marginOptimizationEnabled } = useFeatureFlag(
		"Margin Optimization",
		false
	);

	const processedRows = useMemo(() => {
		const sourceRows = Array.isArray(tableRows) ? tableRows : [];
		const rowsWithMargin = sourceRows.map((row) => {
			const parseMoney = (value) => {
				if (value === null || value === undefined || value === "") {
					return null;
				}
				if (typeof value === "number") {
					return value;
				}
				const parsed = parseFloat(value);
				return Number.isNaN(parsed) ? null : parsed;
			};

			const price = parseMoney(row.price);
			const cost = parseMoney(row.cost);
			const margin =
				price !== null && cost !== null ? Number(price - cost) : null;

			return {
				...row,
				margin,
			};
		});

		if (!marginOptimizationEnabled) {
			return rowsWithMargin;
		}

		return [...rowsWithMargin].sort((a, b) => {
			if (a.name === "Gamer") {
				return -1;
			}
			if (b.name === "Gamer") {
				return 1;
			}
			const marginA = a.margin ?? Number.NEGATIVE_INFINITY;
			const marginB = b.margin ?? Number.NEGATIVE_INFINITY;
			return marginB - marginA;
		});
	}, [tableRows, marginOptimizationEnabled]);

	const selectHandler = (model) => {
		if (model.length > 0) {
			var rowId = model[0];
			var row = processedRows.filter((club) => club.id === rowId);
			onSelection(row[0]);
		}
	};
	return (
		<Grid container sx={{ marginTop: 2 }}>
			{headerText && (
				<Typography
					variant="h5"
					sx={{
						width: "100%",
						textOverflow: "ellipsis",
						overflow: "hidden",
						whiteSpace: "nowrap",
					}}
				>
					{headerText}
					{currentSelection?.name
						? ` (Current Selection: ${currentSelection.name})`
						: null}
				</Typography>
			)}
			<Table
				rows={processedRows}
				onSelection={selectHandler}
				famFilterOpts={famFilterOpts}
				manFilterOpts={manFilterOpts}
				onShowAll={onShowAll}
				currentSelection={currentSelection}
				dataType={dataType}
				insufficientData={insufficientData}
			/>
		</Grid>
	);
};

export default Selection;
